export default "/images/bank_cheque.png?1779bf30686dba0e186481cd0b134e6b";